var _defs, _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _path5, _rect5, _rect6, _rect7, _polygon, _polygon2, _path6, _rect8, _rect9, _rect10, _rect11, _path7, _path8, _path9, _path10, _rect12, _rect13, _rect14, _path11, _rect15, _rect16, _rect17, _rect18, _path12, _path13, _path14, _path15, _rect19, _rect20, _rect21, _path16, _rect22, _rect23, _rect24, _rect25, _path17, _path18, _path19, _path20, _rect26, _rect27, _rect28, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _rect29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexBank01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#09B2C9;}.a,.d{fill-rule:evenodd;}.c{fill:#edeeef;}.d{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.21,278.68a13.35,13.35,0,0,0,3.1-8.22h25.61a15.56,15.56,0,0,0,3.51,8.22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 135.81,
    y: 279.86,
    width: 41.02,
    height: 10.11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 135.04,
    y: 278.14,
    width: 42.57,
    height: 2.29,
    rx: 1.14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 142.27,
    y: 268.28,
    width: 28.1,
    height: 2.84,
    rx: 1.42
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 144.08,
    y: 182.58,
    width: 24.49,
    height: 85.68
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149.47,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,149.47,186.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M156.61,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,156.61,186.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M163.74,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,163.74,186.56Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.21,172.69a13.31,13.31,0,0,1,3.1,8.22h25.61a15.56,15.56,0,0,1,3.51-8.22Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 135.81,
    y: 161.4,
    width: 41.02,
    height: 10.11
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 135.04,
    y: 170.94,
    width: 42.57,
    height: 2.29,
    rx: 1.14
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 142.27,
    y: 180.25,
    width: 28.1,
    height: 2.84,
    rx: 1.42
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "315.44 161.4 124.72 161.4 220.08 87.08 315.44 161.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "335.34 168.65 220.12 74.67 220.08 74.6 104.78 168.65 121.37 168.65 220.06 88.15 318.75 168.65 335.34 168.65"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.21,278.68a13.35,13.35,0,0,0,3.1-8.22h25.61a15.56,15.56,0,0,0,3.51,8.22Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 135.81,
    y: 279.86,
    width: 41.02,
    height: 10.11
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 135.04,
    y: 278.14,
    width: 42.57,
    height: 2.29,
    rx: 1.14
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 142.27,
    y: 268.28,
    width: 28.1,
    height: 2.84,
    rx: 1.42
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 144.08,
    y: 182.58,
    width: 24.49,
    height: 85.68
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149.47,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,149.47,186.56Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M156.61,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,156.61,186.56Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M163.74,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,163.74,186.56Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.21,172.69a13.31,13.31,0,0,1,3.1,8.22h25.61a15.56,15.56,0,0,1,3.51-8.22Z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 135.81,
    y: 161.4,
    width: 41.02,
    height: 10.11
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 135.04,
    y: 170.94,
    width: 42.57,
    height: 2.29,
    rx: 1.14
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 142.27,
    y: 180.25,
    width: 28.1,
    height: 2.84,
    rx: 1.42
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M266.22,278.68a13.35,13.35,0,0,0,3.1-8.22h25.61a15.56,15.56,0,0,0,3.51,8.22Z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 261.82,
    y: 279.86,
    width: 41.01,
    height: 10.11
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 261.05,
    y: 278.14,
    width: 42.57,
    height: 2.29,
    rx: 1.14
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 268.28,
    y: 268.28,
    width: 28.1,
    height: 2.84,
    rx: 1.42
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 270.09,
    y: 182.58,
    width: 24.49,
    height: 85.68
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M275.48,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,275.48,186.56Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M282.62,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,282.62,186.56Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M289.75,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,289.75,186.56Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M266.22,172.69a13.31,13.31,0,0,1,3.1,8.22h25.61a15.56,15.56,0,0,1,3.51-8.22Z"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 261.82,
    y: 161.4,
    width: 41.01,
    height: 10.11
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 261.05,
    y: 170.94,
    width: 42.57,
    height: 2.29,
    rx: 1.14
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 268.28,
    y: 180.25,
    width: 28.1,
    height: 2.84,
    rx: 1.42
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M203.22,278.68a13.35,13.35,0,0,0,3.1-8.22h25.6a15.53,15.53,0,0,0,3.52,8.22Z"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 198.82,
    y: 279.86,
    width: 41.01,
    height: 10.11
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 198.04,
    y: 278.14,
    width: 42.56,
    height: 2.29,
    rx: 1.14
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 205.28,
    y: 268.28,
    width: 28.1,
    height: 2.84,
    rx: 1.42
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 207.08,
    y: 182.58,
    width: 24.49,
    height: 85.68
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M212.48,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,212.48,186.56Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M219.61,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,219.61,186.56Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M226.75,186.56h0a2,2,0,0,1,2,2v66.29a2,2,0,0,1-2,2h0a2,2,0,0,1-2-2V188.54A2,2,0,0,1,226.75,186.56Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M203.22,172.69a13.31,13.31,0,0,1,3.1,8.22h25.6a15.53,15.53,0,0,1,3.52-8.22Z"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 198.82,
    y: 161.4,
    width: 41.01,
    height: 10.11
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 198.04,
    y: 170.94,
    width: 42.56,
    height: 2.29,
    rx: 1.14
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 205.28,
    y: 180.25,
    width: 28.1,
    height: 2.84,
    rx: 1.42
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M194.59,147.54V131.36h-5.82a.63.63,0,0,0-.69.67.61.61,0,0,0,.47.59c.76.23.74.36.74,1.16v11.34c0,.8,0,.93-.74,1.17a.59.59,0,0,0-.47.58.63.63,0,0,0,.69.67Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M202.35,135.32a3.55,3.55,0,0,0-2.12-3.33,8.94,8.94,0,0,0-4-.63h-.67v1.26a1.66,1.66,0,0,1,1.62,1.9v2.16c0,.8,0,1.73-1.62,1.86v1.26c1.39.1,1.62,1,1.62,2v2.79c0,.78-.17,1.6-1.62,1.67v1.25h.69a8.18,8.18,0,0,0,4.29-.71,3.79,3.79,0,0,0,2-3.51c0-2.7-1.9-3.76-4.31-4.15v0C200.36,138.8,202.35,137.7,202.35,135.32Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M206.92,144.23l2-7.4-.56-2.44h-.07l-2.59,9.49c-.41,1.54-1,2-1.45,2.28s-.85.21-.85.73.78.65,1.21.65h2.49c.43,0,1.13,0,1.13-.58,0-.44-.31-.57-.65-.72C206.87,145.92,206.57,145.55,206.92,144.23Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M217.17,145l-3.25-13.67h-4.78l-.28,1.17,2.19,9.56h-2.64l-.3,1.25h3.15l.44,1.67c.19.84.1,1-.46,1.32-.28.15-.41.26-.41.6,0,.57.63.61,1.06.61h5.39c.41,0,1.19,0,1.19-.56,0-.39-.24-.54-.54-.67C217.32,146.05,217.3,145.64,217.17,145Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M232.4,142.31l-6.3-10.95h-5.56c-.45,0-1.1,0-1.1.67,0,.48.28.56.65.69.71.24.82.57,1.17,1.17l7.91,13.65h3.23Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M222.38,144.12v-6.53l-1.21-2.16h0v8.69c-.35,2.71-1.73,1.86-1.73,2.79,0,.67.88.63,1.12.63H223c.24,0,1.12,0,1.12-.63C224.11,146,222.73,146.83,222.38,144.12Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M232.4,135.28c0-3.1,1.77-2.28,1.77-3.27,0-.61-.71-.65-.93-.65H230.3c-.22,0-.93,0-.93.65,0,1,1.77.17,1.77,3.27v3.07l1.21,2.18h.05Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M243.86,132c0-.63-.71-.67-.8-.67h-6.12c-.09,0-.8,0-.8.67a.61.61,0,0,0,.47.59c.76.23.74.36.74,1.16v11.34c0,.8,0,.93-.74,1.17a.59.59,0,0,0-.47.58c0,.63.71.67.8.67h6.12c.09,0,.8,0,.8-.67a.6.6,0,0,0-.48-.58c-.75-.24-.73-.37-.73-1.17V133.78c0-.8,0-.93.73-1.16A.62.62,0,0,0,243.86,132Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M250.63,132.88c.39-.16.8-.31.8-.8,0-.7-.63-.72-1.15-.72h-3.7c-.45,0-1.05,0-1.05.65,0,.43.32.52.67.67a1.12,1.12,0,0,1,.82,1.1,2.3,2.3,0,0,1-.57,1.37l-2.5,3.56a1.85,1.85,0,0,0-.5,1.11,4.51,4.51,0,0,0,.28,1.32l1.34,4a2.08,2.08,0,0,1,.17.65c0,.48-.88.35-.88,1.06s.65.67,1.14.67h5.43c.43,0,1.15,0,1.15-.58,0-.42-.2-.55-.52-.7-.5-.23-.56-.6-.76-1.08l-3.48-9.13.41-.56C248.64,134.26,249.14,133.44,250.63,132.88Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M131.67,289.18H308.72a5,5,0,0,1,4.76,5.15h0a5,5,0,0,1-4.76,5.14H131.67a5,5,0,0,1-4.75-5.14h0A5,5,0,0,1,131.67,289.18Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M120.11,298H320.29a4.77,4.77,0,0,1,4.76,4.75h0a4.76,4.76,0,0,1-4.76,4.75H120.11a4.76,4.76,0,0,1-4.76-4.75h0A4.77,4.77,0,0,1,120.11,298Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M109.5,306H330.9a4.77,4.77,0,0,1,4.75,4.75h0a4.77,4.77,0,0,1-4.75,4.76H109.5a4.77,4.77,0,0,1-4.75-4.76h0A4.77,4.77,0,0,1,109.5,306Z"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 104.75,
    y: 314.7,
    width: 230.9,
    height: 9.5,
    rx: 4.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexBank01);
export default __webpack_public_path__ + "static/media/Vortex_Bank-01.dd0fede765f59860bff76a51849bd561.svg";
export { ForwardRef as ReactComponent };